import { getApi, postApi } from "@/utils/callApi";
import apiConfig from "@/utils/apiConfig";
import Swal from "sweetalert2";


var LoadData = {
    //載入旅遊國家清單
    getCountryList(callback) {
        let countryList = sessionStorage.getItem('countryList');
        if (countryList != null) {
            if (callback) {
                callback(JSON.parse(countryList));
            }
        } else {
            getApi(apiConfig.countryList)
                .then((response) => {
                    var countryListRes = response.data;
                    if (countryListRes.code === 200) {
                        sessionStorage.setItem('countryList', JSON.stringify(countryListRes.data));
                        if (callback) {
                            callback(countryListRes.data);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ countryListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    const self = this;
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>國家資料載入錯誤</p>',
                    })
                })
        }
    },
    //載入國籍清單
    getRiskCountryList(callback) {
        let riskCountryList = sessionStorage.getItem('riskCountryList');
        if (riskCountryList != null) {
            if (callback) {
                callback(JSON.parse(riskCountryList));
            }
        } else {
            getApi(apiConfig.riskCountryList)
                .then((response) => {
                    var riskCountryListRes = response.data;
                    if (riskCountryListRes.code === 200) {
                        sessionStorage.setItem('riskCountryList', JSON.stringify(riskCountryListRes.data));
                        if (callback) {
                            callback(riskCountryListRes.data);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ riskCountryListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>國籍資料載入錯誤</p>',
                    })
                })
        }
    },
    //載入職行業清單
    getRiskJobList(callback) {
        let riskJobList = sessionStorage.getItem('riskJobList');
        if (riskJobList != null) {
            if (callback) {
                callback(JSON.parse(riskJobList));
            }
        } else {
            getApi(apiConfig.riskJobList)
                .then((response) => {
                    var riskJobListRes = response.data;
                    if (riskJobListRes.code == 200) {
                        sessionStorage.setItem('riskJobList', JSON.stringify(riskJobListRes.data.items));
                        if (callback) {
                            callback(riskJobListRes.data.items);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ riskJobListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>職行業資料載入錯誤</p>',
                    })
                })
        }
    },
    //載入縣市清單
    getAddrCityList(callback) {
        let addrCityList = sessionStorage.getItem('addrCityList');
        if (addrCityList != null) {
            if (callback) {
                callback(JSON.parse(addrCityList));
            }
        } else {
            getApi(apiConfig.addrCityList)
                .then((response) => {
                    var addrCityListRes = response.data;
                    if (addrCityListRes.code == 200) {
                        sessionStorage.setItem('addrCityList', JSON.stringify(addrCityListRes.data.items));
                        if (callback) {
                            callback(addrCityListRes.data.items);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ addrCityListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>縣市資料載入錯誤</p>',
                    })
                })
        }
    },
    //載入區域清單
    getAddrZipList(cityCode, callback) {
        getApi(apiConfig.addrZipList + '?code=' + cityCode)
            .then((response) => {
                var addrZiplistRes = response.data;
                if (addrZiplistRes.code == 200) {
                    if (callback) {
                        callback(addrZiplistRes.data.items);
                    }
                } else {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>'+ addrZiplistRes.message + '</p>',
                    });
                }
            })
            .catch((error) => {
                //跳出錯誤
                Swal.fire({
                    title: "頁面載入錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>區域資料載入錯誤'+ error + '</p>',
                })
            })
    },
    //載入銀行清單
    getBankList(callback){
        let bankList = sessionStorage.getItem('bankList');
        if (bankList != null) {
            if (callback) {
                callback(JSON.parse(bankList));
            }
        } else {
            getApi(apiConfig.bankList)
                .then((response) => {
                    var bankListRes = response.data;
                    if (bankListRes.code == 200) {
                        sessionStorage.setItem('bankList', JSON.stringify(bankListRes.data.items));
                        if (callback) {
                            callback(bankListRes.data.items);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ bankListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>銀行資料載入錯誤</p>',
                    })
                })
        }
    },
    //載入KYC
    getKyc(callback){
        let kycList = sessionStorage.getItem('kycList');
        if (kycList != null) {
            if (callback) {
                callback(JSON.parse(kycList));
            }
        } else {
            getApi(apiConfig.getKyc)
                .then((response) => {
                    var kycListRes = response.data;
                    if (kycListRes.code == 200) {
                        sessionStorage.setItem('kycList', JSON.stringify(kycListRes.data));
                        if (callback) {
                            callback(kycListRes.data);
                        }
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ kycListRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>KYC資料載入錯誤</p>',
                    })
                })
        }
    }

}
export default LoadData;